import * as React from "react";
import Drawer from "@mui/material/Drawer";

import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

import { NavLink, useMatch } from "react-router-dom";
// import { FaListUl, FaRegUserCircle } from "react-icons/fa";
// import { PiShareNetworkDuotone } from "react-icons/pi";
// import { TbUsers } from "react-icons/tb";
// import { TfiWallet } from "react-icons/tfi";
// import { GiProtectionGlasses } from "react-icons/gi";
// import PhotoCameraFrontIcon from "@mui/icons-material/PhotoCameraFront";
import CopyrightIcon from "@mui/icons-material/Copyright";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import UserService from "rc-app/services/UserService";

import { getAgencyLogo } from "rc-app/api/agencyActionsApi";
import { determineAgencyType } from "rc-app/utils";
import Icon from "../Icons";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function MobileDrawer({ open, setOpen }: any) {
  const [agencyLogoUrl, setAgencyLogoUrl] = React.useState(null);
  React.useEffect(() => {
    // getAgencyLogo(UserService.getUseremail()).then((res) => {
    //   setAgencyLogoUrl(res.logo);
    //   console.log("agencyLogo1", determineAgencyType({ regions: res.region }));
    // });
    // UserService.hasRole("agent") &&
    getAgencyLogo(UserService.getUseremail()).then((res) => {
      setAgencyLogoUrl(res.logo);
      console.log("agencyLogo1", determineAgencyType({ regions: res.region }));
      // Cache for instant first-paint in pages like ProjectDetailsV3's EntryLoader.
      try {
        if (res?.logo) localStorage.setItem("agencyLogo", res.logo);
      } catch { /* localStorage unavailable — silent */ }
    });
    // UserService.hasRole("customer") && setAgencyLogoUrl("string");
  }, []);

  const Home = useMatch("/");
  const Agency = useMatch("/agency_list");
  const MyCustomers = useMatch("/customers");

  // const Network = useMatch("/network_list");
  // const Earnings = useMatch("/earnings");

  // const Virtual = useMatch("/vr_tour_list");

  // const JoinVrTour = useMatch("/join_vr_tour");
  // const MyAgent = useMatch("/my_agent");

  const Profile = useMatch("/profile");

  // const ProductFeatures = useMatch("/product_features");
  // const Pricing = useMatch("/pricing");
  // const SellWithUs = useMatch("/sell_with_us");
  // const AboutUS = useMatch("/about_us");

  // const currentUrl = window.location.href;
  // const url = new URL(currentUrl);
  // const path = url.pathname;

  const DrawerList = (
    <nav className=" w-[208px] ">
      {UserService.isLoggedIn() && (
        <ul className="flex flex-col gap-2">
          {UserService.hasRole("agent") && (
            <>
              <li
                className={`flex items-center ${
                  Home || Agency
                    ? "  bg-[#1C2C3A] rounded-md font-normal text-base"
                    : ""
                }`}
              >
                <NavLink
                  to="/agency_list"
                  className="flex items-center text-white gap-4 p-3 w-full"
                  onClick={() => setOpen(false)}
                >
                  <Icon
                    name="ic-home"
                    className="w-5 h-5 text-white cursor-pointer"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />{" "}
                  My Projects
                </NavLink>
              </li>
              <li
                className={`flex items-center ${
                  MyCustomers
                    ? " bg-[#1C2C3A] rounded-md font-normal text-base"
                    : ""
                }`}
              >
                <NavLink
                  to="/customers"
                  className="flex items-center text-white gap-4 p-3 w-full"
                >
                  <Icon
                    name="ic-customers"
                    className="w-5 h-5 text-white cursor-pointer"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />{" "}
                  My Customers
                </NavLink>
              </li>
            </>
          )}


          {!UserService.hasRole("customer") && (
            <li
              className={`flex items-center ${
                Profile ? " bg-[#1C2C3A] rounded-md font-normal text-base" : ""
              }`}
            >
              <NavLink
                to="/profile"
                className="flex items-center text-white gap-4 p-3 w-full"
                onClick={() => setOpen(false)}
              >
                <Icon
                  name="ic-account_circle"
                  className={`w-5 h-5 text-white cursor-pointer ${
                    open ? "opacity-100" : "opacity-0 w-0 h-0"
                  }`}
                  style={{ filter: "brightness(0) invert(1)" }}
                />
                My Profile
              </NavLink>
            </li>
          )}
        </ul>
      )}

      {/* {!UserService.isLoggedIn() && (
        <ul className="flex flex-col gap-2">
          <li
            className={`flex items-center ${
              ProductFeatures || path === "/"
                ? "text-[#FF307A] font-semibold"
                : "text-white"
            }`}
          >
            <NavLink
              to="/product_features"
              className="flex items-center gap-4 py-2 pl-5 pr-3 w-full"
            >
              Product Features
            </NavLink>
          </li>
          <li
            className={`flex items-center ${
              Pricing ? " text-[#FF307A] font-semibold" : "text-white"
            }`}
          >
            <NavLink
              to="#"
              className="flex items-center gap-4 py-2 pl-5 pr-3 w-full"
              onClick={(e) => {
                e.preventDefault(); // Prevent default NavLink behavior
                window.open(
                  "https://italia.1verse.live/pages/pricing-1",
                  "_blank",
                  "noopener noreferrer"
                );
              }}
            >
              Pricing
            </NavLink>
          </li>
          <li
            className={`flex items-center ${
              SellWithUs ? "text-[#FF307A] font-semibold" : "text-white"
            }`}
          >
            <NavLink
              to="/sell_with_us"
              className="flex items-center gap-4 py-2 pl-5 pr-3 w-full"
            >
              Sell With Us
            </NavLink>
          </li>
          <li
            className={`flex items-center ${
              AboutUS ? "text-[#FF307A] font-semibold" : "text-white"
            }`}
          >
            <NavLink
              to="/#"
              className="flex items-center gap-4 py-2 pl-5 pr-3 w-full"
              onClick={(e) => {
                e.preventDefault(); // Prevent default NavLink behavior
                window.open(
                  "https://italia.1verse.live/",
                  "_blank",
                  "noopener noreferrer"
                );
              }}
            >
              About US
            </NavLink>
          </li>

          <div className="w-full h-full flex pl-5">
            <Button
              children="Login"
              className="bg-[#FF307A] h-full font-semibold px-4 rounded-sm"
              onClick={() => UserService.doLogin()}
            />
          </div>
          <li className="flex items-center"></li>
        </ul>
      )} */}
    </nav>
  );

  return (
    <div className="">
      <Drawer
        open={open}
        onClose={() => setOpen(!open)}
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: !UserService.isLoggedIn() ? "#000524" : "#2E4051",
            paddingX: "16px",
            zIndex: 1300,
          },
        }}
        ModalProps={{
          BackdropProps: {
            style: {
              backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent backdrop
            },
          },
          disableScrollLock: false, // Allows proper scrolling
        }}
      >
        <DrawerHeader sx={{ paddingY: ".8rem" }}>
          <div className="h-[8vh]  flex items-center justify-center">
            <Link
              to="/"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {agencyLogoUrl == null ? (
                // Show nothing while loading
                <div
                  style={{
                    width: "clamp(40px, 15vw, 120px)",
                    height: "clamp(40px, 15vw, 120px)",
                  }}
                />
              ) : (
                // Show either agency logo or default logo
                <img
                  alt="Opensky"
                  src={agencyLogoUrl || "/images/logoColoured.svg"}
                  className="object-cover w-36 h-12 "
                />
              )}

              {/* <img
                alt="Opensky"
                // src="https://storage.googleapis.com/oneverse-dev/realestate/1verse_logo_pink.png"
                src="/images/logoColoured.svg"
                style={{ height: "auto", width: "100%", maxWidth: "150px" }}
              /> */}
              {/* <h5 className=" text-[#1B191B] text-2xl font-bold flex">
                1verse
              </h5> */}
              {/* <img
                    alt="1verse"
                    src="https://storage.googleapis.com/oneverse-dev/realestate/1verse-logo-2.png"
                    className="h-12 w-12 flex md:hidden "
                  />
                  <h5 className=" text-[#1B191B] text-2xl font-bold flex md:hidden">
                    1verse
                  </h5> */}
            </Link>
          </div>
        </DrawerHeader>
        {DrawerList}
        <div
          className={` absolute bottom-[10px]  ${
            open ? " inset-x-0 flex items-center justify-center flex-col" : ""
          }`}
        >
          {open ? (
            <div className="flex items-center ">
              <span className="text-[0rem] text-[#889DB2]">
                {" "}
                <CopyrightIcon />{" "}
              </span>
              <span className="text-[#889DB2] text-[1rem]"> Powered by </span>
            </div>
          ) : null}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              alt="Opensky"
              // src="/images/logo.svg"
              src={`${process.env.REACT_APP_UPLOADED_URL}/realestate/logo.png`}
              className={`object-cover w-24 h-8 transition-opacity ${
                open ? "opacity-100" : "opacity-0 w-0 h-0"
              }`}
            />
          </div>
        </div>
      </Drawer>
    </div>
  );
}
